import { isNullOrUndefined, objectHasKeys } from '@/utils/comparators'

const isLoading = state => state.loading

const getCountries = (state) => {
  return state.countries
}

const getCountryIds = (state) => {
  if (objectHasKeys(state.countries)) {
    return Object.keys(state.countries)
  }
  return null
}

const getCountryById = (state) => (id) => {
  if (objectHasKeys(state.countries)) {
    return state.countries[id]
  }
  return null
}

const getCountriesByIds = state => (ids) => {
  if (objectHasKeys(state.countries)) {
    return ids.map(id => state.countries[id]).filter(x => x !== undefined) // We use filter to prevent miss mapping like KN case
  }
  return null
}

const findCountryByToken = (state) => (searchToken, limit) => {
  let countries = objectHasKeys(state.countries) ? Object.values(state.countries) : []

  searchToken = searchToken.trim()

  let result = countries.filter((country) => {
    for (const token of country.tokens) {
      if (token.toLowerCase().startsWith(searchToken.toLowerCase())) {
        return true
      }
    }
  })

  let sorted = result.sort(function (a, b) {
    if (parseInt(a.importance) > parseInt(b.importance)) {
      return -1
    }
    return parseInt(a.importance) < parseInt(b.importance)
      ? 1
      : 0
  })

  return limit === 0
    ? sorted
    : sorted.slice(0, limit)
}

const findCountryByTokenV2 = (state) => (searchToken, limit, localNames, includeOnly) => {
  if (!objectHasKeys(state.countries)) {
    return []
  }

  let countries = []

  if (isNullOrUndefined(includeOnly)) {
    countries = Object.values(state.countries)
  } else {
    countries = includeOnly.map(id => state.countries[id])
  }

  searchToken = searchToken.trim().toLowerCase()

  let localized = []

  countries.forEach(country => {
    if (isNullOrUndefined(country)) {
      return
    }

    localized.push({
      id: country.id,
      callingcode: country.callingcode,
      name: localNames[country.id],
      tokens: country.tokens
    })
  })

  let filteredByInitial = localized.filter((country) => {
    return country.name.toLowerCase().startsWith(searchToken)
  })

  if (filteredByInitial.length >= limit) {
    return filteredByInitial.slice(0, limit)
  }

  for (const country of localized) {
    for (const token of country.tokens) {
      if (token.toLowerCase().startsWith(searchToken.toLowerCase()) && !filteredByInitial.includes(country)) {
        filteredByInitial.push(country)
      }
    }
    if (filteredByInitial.length >= limit) {
      break
    }
  }
  return filteredByInitial
}

export default {
  isLoading,
  getCountryById,
  getCountriesByIds,
  findCountryByToken,
  findCountryByTokenV2,
  getCountries,
  getCountryIds
}



// WEBPACK FOOTER //
// ./src/store/modules/app/getters.js